import { createSelector } from 'reselect';
import { RootState } from 'Store/Reducers/RootReducer';

const getUserStore = (state: RootState) => state.userStore;
const usersList = createSelector(getUserStore, (state) => state.usersList);
const usersLabel = createSelector(getUserStore, (state) => state.usersLabel);

export { usersList, usersLabel };
